<div class="section-tag-container" [class.section-tag-container-t2]="theme() === GbTheme.ThemeTwo">
  @if (theme() === GbTheme.ThemeTwo) {
    <span class="section-tag-icon">
      <svg
        class="rtl"
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
      >
        <path
          d="M9.28049 18.0684C9.17934 13.0794 5.01756 9.04676 -0.000815727 9.0487C5.01756 9.04676 8.99334 4.98913 8.89218 0.00018837C8.99334 4.98913 13.1551 9.02177 18.1735 9.01983C13.1551 9.02177 9.17934 13.0794 9.28049 18.0684Z"
          fill="#1D9CFE"
        />
      </svg>
    </span>
  }

  @if (theme() === GbTheme.ThemeOne) {
    <span class="section-tag-icon">
      <svg
        class="rtl"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M14.1516 3C14.3618 3.00006 14.5495 3.13157 14.6213 3.3291L16.5471 8.625H20.9016C21.1118 8.62506 21.2995 8.75657 21.3713 8.9541L23.4397 14.6416C23.4798 14.752 23.4798 14.873 23.4397 14.9834L21.3713 20.6709C21.2995 20.8684 21.1118 20.9999 20.9016 21H8.46507C8.11834 20.9997 7.87686 20.655 7.99534 20.3291L9.7971 15.375H1.71507C1.36834 15.3747 1.12686 15.03 1.24534 14.7041L3.18967 9.3584C3.2298 9.24804 3.2298 9.12696 3.18967 9.0166L1.24534 3.6709C1.12686 3.34496 1.36834 3.00029 1.71507 3H14.1516Z"
          fill="white"
        />
        <g style="mix-blend-mode: multiply">
          <path
            class="primary-color"
            d="M1.24395 3.67087C1.12537 3.34478 1.36687 3 1.71385 3H14.1498C14.36 3 14.5478 3.13153 14.6197 3.32913L16.6879 9.01663C16.728 9.12701 16.728 9.24799 16.6879 9.35837L14.6197 15.0459C14.5478 15.2435 14.36 15.375 14.1498 15.375H1.71385C1.36687 15.375 1.12537 15.0302 1.24395 14.7041L3.18786 9.35837C3.228 9.24799 3.228 9.12701 3.18786 9.01663L1.24395 3.67087Z"
            fill="#3D38D0"
          />
        </g>
        <g style="mix-blend-mode: multiply">
          <path
            class="primary-medium-color"
            d="M7.99395 9.29587C7.87537 8.96978 8.11687 8.625 8.46385 8.625H20.8998C21.11 8.625 21.2978 8.75653 21.3697 8.95413L23.4379 14.6416C23.478 14.752 23.478 14.873 23.4379 14.9834L21.3697 20.6709C21.2978 20.8685 21.11 21 20.8998 21H8.46385C8.11687 21 7.87537 20.6552 7.99395 20.3291L9.93786 14.9834C9.978 14.873 9.978 14.752 9.93786 14.6416L7.99395 9.29587Z"
            fill="#9E9BFF"
          />
        </g>
      </svg>
    </span>
  }
  <p class="section-tag-text primary-font-medium">{{ text }}</p>
</div>
